import { KeyValueObj } from "@/common/types";

export const tableKeys = ["name", "tin", "address", "email", "action"];
export const unlinkedKeys = ["name", "tin", "address", "email"];

export const tableHeaders = ["Company Name", "TIN Number", "Address", "Email"];

export const unlinkedHeaders = [
  "Company Name",
  "TIN Number",
  <div style={{ minWidth: "15rem" }}>Address</div>,
  "Email",
];

export const tableData = [
  {
    id: "1",
    name: {
      type: "string",
      value: "Quado Distributions",
    },
    tin: {
      type: "string",
      value: "TIN7828284",
    },
    address: {
      type: "string",
      value: "Number 11 new man Road, Yaba, Kogi state",
    },
    email: {
      type: "string",
      value: "engchikwas404@gmail.com",
    },
    action: {
      type: "button",
      buttonType: "dots",
      onclick: () => console.log("clicked"),
    },
  },
  {
    id: "1",
    name: {
      type: "string",
      value: "Francis Distributions",
    },
    tin: {
      type: "string",
      value: "TIN7828284",
    },
    address: {
      type: "string",
      value: "no 16, 123 road, Kado estate, Abuja",
    },
    email: {
      type: "string",
      value: "israelite404@gmail.com",
    },
    action: {
      type: "button",
      buttonType: "dots",
      onclick: () => console.log("clicked"),
    },
  },
];

export const singleDistributorData = [
  {
    inputType: "email",
    prompt: "Company email address",
    name: "email",
    placeholder: "Enter the company's email address",
    fullWidth: true,
    rules: {
      isEmail: {
        expectedValue: true,
        errorMessage: "Not a valid email address",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Company Phone number",
    name: "phone",
    placeholder: "Enter the company's phone number",
    fullWidth: true,
  },
];

export const handleRelationship = (data: KeyValueObj): KeyValueObj => {
  const result = {
    name: data?.manufacturer?.name || data?.name,
    corporate_address:
      data?.manufacturer?.corporate_address || data?.corporate_address,
    email: data?.manufacturer?.email || data?.email,
    phone_number: data?.manufacturer?.phone_number || data?.phone_number,
    rc_number: data?.manufacturer?.rc_number || data?.rc_number,
    tin: data?.manufacturer?.tin || data?.tin,
    classification: data?.manufacturer?.classification || data?.classification,
    date_of_establishment:
      data?.manufacturer?.date_of_establishment || data?.date_of_establishment,
    medex_code: data?.manufacturer?.medex_code || data?.medex_code,
    company_status: data?.manufacturer?.company_status || data?.company_status,
    type: data?.manufacturer?.type || data?.type,
    state: data?.manufacturer?.state || data?.state,
    local_govt: data?.manufacturer?.local_govt || data?.local_govt,
    status: data?.manufacturer?.status || data?.status,
  };
  return result;
};
